// components/Atoms/Status/Status.js
import PropTypes from 'prop-types';

const VARIANT_CLASSES = {
  released: 'status-released',
  upcoming: 'status-upcoming',
  draft: 'status-draft',
  archived: 'status-archived',
};

const Status = ({ variant = 'draft', children, className = '' }) => {
  const variantClass = VARIANT_CLASSES[variant] || '';
  
  return (
    <span className={`status ${variantClass} ${className}`.trim()}>
      {children}
    </span>
  );
};

Status.propTypes = {
  variant: PropTypes.oneOf(['released', 'upcoming', 'draft', 'archived']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Status;